<template>
	<div>
		<div class="row">
			<div class="col-sm-2">
				<b>Status</b>
				<select v-model="status" class="form-control">
					<option value="all">Todos</option>
					<option value="0">Novos</option>
					<option value="1">Iniciados</option>
					<option value="2">Finalizados</option>
				</select>
			</div>

			<div class="col-sm-3">
				<b>Contrato / Cód. Interno</b>
				<input v-model="cod" type="text" class="form-control" />
			</div>
			<div class="col-sm-7">
				<b>Serviço/Tarefa</b>
				<input v-model="serv_tar" type="text" class="form-control" />
			</div>

			<div class="col-sm-7">
				<b>Cliente</b>
				<input v-model="cliente" type="text" class="form-control" />
			</div>
			<div class="col-sm-2">
				<b>Região</b>
				<select v-model="regiao" class="form-control">
					<option value="all">Todas</option>
					<option
						v-for="(reg, index) in assets.regioes"
						:key="index"
						:value="reg.regiao"
					>
						{{ reg.localidade }}
					</option>
				</select>
			</div>
			<div class="col-sm-3">
				<b>Intervalo</b>
				<div class="input-group">
					<span class="input-group-addon">
						<i class="fa fa-calendar"></i>
					</span>
					<div class="form-control" id="datepicker-trigger">
						{{ fDate(dateOne) }} - {{ fDate(dateTwo) }}
					</div>
				</div>
				<div class="cnt-airbnb">
					<div class="airbnb">
						<AirbnbStyleDatepicker
							id="wrapper-date"
							trigger-element-id="datepicker-trigger"
							:mode="'range'"
							:months-to-show="2"
							:date-one="dateOne"
							:date-two="dateTwo"
							:fullscreen-mobile="true"
							@date-one-selected="
								(val) => {
									dateOne = val;
								}
							"
							@date-two-selected="
								(val) => {
									dateTwo = val;
								}
							"
						/>
						<!--
					        @closed='update' -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import fDate from 'js/date';
	import { mapState } from 'vuex';
	import WBS from 'js/http';

	export default {
		data() {
			let iniData = new Date();
			iniData.setMonth(iniData.getMonth() - 1);

			let hoje = new Date();
			hoje.setDate(hoje.getDate() + 15);
			return {
				cod: '',
				status: 'all',
				serv_tar: '',
				cliente: '',
				regiao: 'all',
				dateOne: iniData,
				dateTwo: hoje,

				assets: {
					regioes: [],
					vendedores: [],
				},
			};
		},
		methods: {
			IsolarCliente(cnpj) {
				this.cliente = cnpj;
				this.update();
			},
			fDate(data, mask = 'DD xmxs') {
				let date = new Date(data);
				date.setDate(date.getDate() + 1);
				return fDate(date, mask);
			},
			update() {
				let search = [];
				search.push(`depto = '${this.depto.cod}'`);

				search.push(
					` ( dInicio > '${this.fDate(
						this.dateOne,
						'YY-MM-DD'
					)}' and dInicio < '${this.fDate(
						this.dateTwo,
						'YY-MM-DD'
					)}' ) `
				);

				if (this.status != 'all') {
					search.push(`status = ${this.status}`);
				}

				if (this.serv_tar != '') {
					search.push(
						`( servico like '%${this.serv_tar}%' or tarefa like '%${this.serv_tar}%' )`
					);
				}

				if (this.cliente != '') {
					search.push(
						`( cnpj like '%${this.cliente}%' or cliente like '%${this.cliente}%' )`
					);
				}

				if (this.regiao != 'all') {
					search.push({
						find: 'cod',
						out: 'contrato',
						table: 'contrato',
						where: {
							find: 'cod',
							out: 'cod_proposta',
							table: 'propostas',
							where: `regiao like '%${this.regiao}%'`,
						},
					});
				}

				if (this.cod != '') {
					search.push({
						find: 'cod',
						out: 'contrato',
						table: 'contrato',
						where: ` cod_interno like '%${this.cod}%' or cod like '%${this.cod}%' `,
					});
				}

				this.$emit('updateTab', search);
			},
		},
		computed: {
			...mapState({
				depto: (s) => s.user_data.uid.departamento,
			}),
		},
		mounted() {
			WBS.send('protected-read-assetsPropostas', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
				}
			});
			$('.form-control').change(this.update);
			$('.action-buttons > button:nth-child(2)').click(this.update);
		},
	};
</script>
<style>
	.airbnb-style-datepicker-wrapper {
		position: absolute !important;
		width: 600px !important;
		z-index: 100 !important;
		top: 41px !important;
		right: 0px !important;
		left: 0px !important;
	}
	div.datepicker-inner-wrapper {
		margin: 3px 0 0 0 !important;
	}
	.airbnb {
		position: absolute;
		right: 601px;
		top: -40px;
	}
	.cnt-airbnb {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/filter.vue